// Flying Cart Animation
document.addEventListener('DOMContentLoaded', function() {
  // Listen for add to cart events
  document.addEventListener('cart:item-added', function(event) {
    const button = event.detail?.button;
    if (!button) return;
    
    // Find the product image
    const card = button.closest('.card-wrapper') || button.closest('.product');
    const productImage = card?.querySelector('img');
    if (!productImage) return;
    
    // Get cart icon position. On mobile the header cart icon is hidden
    // (display: none, replaced by the bottom tab bar), which would make it
    // report a zero-size rect at the top-left corner and send the flying
    // image to the wrong place — target the tab bar's cart item instead.
    const isMobileNav = window.matchMedia('(max-width: 767px)').matches;
    const cartIcon = isMobileNav
      ? document.querySelector('.amana-mobile-nav__item--cart .amana-mobile-nav__cart-wrapper') ||
        document.querySelector('.amana-mobile-nav__item--cart')
      : document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
    if (!cartIcon) return;
    
    const cartRect = cartIcon.getBoundingClientRect();
    const imageRect = productImage.getBoundingClientRect();
    
    // Create flying image
    const flyingImg = document.createElement('img');
    flyingImg.src = productImage.src;
    flyingImg.className = 'flying-image';
    flyingImg.style.width = imageRect.width + 'px';
    flyingImg.style.height = imageRect.height + 'px';
    flyingImg.style.left = imageRect.left + 'px';
    flyingImg.style.top = imageRect.top + 'px';
    
    // Calculate flight path
    const deltaX = cartRect.left - imageRect.left;
    const deltaY = cartRect.top - imageRect.top;
    flyingImg.style.setProperty('--fly-x', deltaX + 'px');
    flyingImg.style.setProperty('--fly-y', deltaY + 'px');
    
    document.body.appendChild(flyingImg);
    
    // Bounce cart icon
    cartIcon.classList.add('cart-icon-bounce');
    
    // Clean up
    setTimeout(() => {
      flyingImg.remove();
      cartIcon.classList.remove('cart-icon-bounce');
    }, 800);
  });
  
  // Intercept quick add submissions
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;
    
    if (url?.includes('/cart/add') && options?.method === 'POST') {
      const button = document.activeElement;
      
      return originalFetch.apply(this, args).then(response => {
        if (response.ok) {
          document.dispatchEvent(new CustomEvent('cart:item-added', { 
            detail: { button } 
          }));
        }
        return response;
      });
    }
    
    return originalFetch.apply(this, args);
  };
});
